import * as React from "react";

const Input = React.forwardRef(
  ({ className, type, iconShow, icon, heightClass = "h-[70px]", ...props }, ref) => {
    return (
      <div className="w-full relative">
        <input
          type={type}
          className={`flex ${heightClass} w-full rounded-lg border-1 border-input bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
          ref={ref}
          {...props}
        />
        <div
          className={`${
            iconShow ? "absolute" : "hidden"
          }  right-2 top-1/2 transform -translate-y-1/2`}
        >
          {icon}
        </div>
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
